import type { FaireProductEntity } from "../../entity_types/product";

export const p_o4m275r: FaireProductEntity = {
  token: "p_o4m275r",
  type: "product",
  name: "Flor de Cactus Moisturizer",
  brandName: "Nopalera",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/b34464b5a65b50214b7ceb7a83558d4920cd6006398ce9027d33c64412731464.webp",
  priceDollars: 28,
  description: "Cactus flower moisturizer",
  categoryTokens: ["cat_bath-all"],
  tags: ["premium", "organic", "moisturizer"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/81e61382f9157e0e28a8c44c69ac1859d7a16c4524e699b09c8a4d39c773bdf5.webp",
  weight: 0.4,
  dimensions: {
    width: 2,
    height: 5,
    depth: 2,
  },
  inStock: true,
};
